import { ValidatorFn, FormControl } from '@angular/forms';
import { FileExtensions } from './file-extension.enum';

export function fileValidator(): ValidatorFn {
  return (control: FormControl) => {
    const file: File = control.value;

    if (file && !file.type) {
      const fileStr = file.name ? file.name : file as any as string;
      const extension = fileStr.substr(
        fileStr.lastIndexOf('.') <= fileStr.length - 3 ? 
        fileStr.lastIndexOf('.') + 1 :
        0,
        fileStr.length
      ).toUpperCase();

      if ((Object as any).keys(FileExtensions).indexOf(extension) === -1) {
        return { fileValidator: true };
      }
    }

    if (file && file.type) {
      if ((Object as any).keys(FileExtensions).map(type => FileExtensions[type]).indexOf(file.type) === -1) {
        return { fileValidator: true };
      }

      return null;
    }

    return null;
  };
}
